import React, { useRef, useState } from 'react';
import ENUMS from '../../enums/index';
import DatePicker from './../../components/FormElements/DatePicker/DatePicker';
import './userTable.scss';
import Select from 'react-select';

const UserFilters = props => {
  let formRefrence = useRef();
  let [startDate, setStartDate] = useState(' ');
  let [endDate, setEndDate] = useState(' ');
  let [fullName, setFullName] = useState();
  let [userName, setUserName] = useState();
  let [selectedStatusCheckbox, setSelectedStatusCheckbox] = useState([]);
  let [mobileNumber, setMobileNumber] = useState();
  let [cityName, setCityName] = useState('');

  function handleEndDataChange(v) {
    if (startDate > v) {
      console.log(startDate, endDate, 'if');
      setEndDate(' ');
    } else {
      console.log(startDate, endDate, 'else');
      setEndDate(v);
    }
  }

  const resetForm = event => {
    Array.from(formRefrence.current).forEach(element => {
      if (element.type === 'radio' || element.type === 'checkbox') {
        element.checked = null;
      } else if (element.name === 'resetButton') {
        element.value = locales('fields.reset');
      } else {
        element.value = null;
      }
    });
    setFullName('');
    setUserName('');
    setMobileNumber('');
    setSelectedStatusCheckbox(null);
    setStartDate(' ');
    setEndDate(' ');
    setCityName('');
    props.applyFilters(event);
  };

  return (
    <article>
      <form
        ref={formRefrence}
        onReset={event => resetForm(event)}
        onSubmit={event => props.applyFilters(event)}
        id='filterForm'
        className='card card my-4'
      >
        <header className='text-center card-header'>
          <h5 className='font-italic text-muted'>{locales('titles.filter')}</h5>
        </header>
        <main className='card-body'>
          <div className='d-flex flex-wrap justidy-content-between px-1'>
            <div className='d-flex flex-column col-md-4 col-12 pb-3'>
              <input
                onChange={event => setFullName(event.target.value)}
                value={fullName || ''}
                name='fullNamePart'
                type='text'
                className='form-control col-12'
                placeholder={locales('tables.fullName')}
                maxLength={ENUMS.MAX_LENGTH.fullName}
              />
              <small style={{ color: '#ccc' }}>{locales('maxLength.50')}</small>
            </div>
            <div className='d-flex flex-column col-md-4 col-12 pb-3'>
              <input
                onChange={event => setUserName(event.target.value)}
                value={userName || ''}
                name='userNamePart'
                type='text'
                className='form-control col-12'
                placeholder={locales('messages.username')}
                maxLength={ENUMS.MAX_LENGTH.userName}
              />
            </div>
            <div className='d-flex flex-column col-md-4 col-12 pb-3'>
              <input
                onChange={event => setMobileNumber(event.target.value)}
                value={mobileNumber || ''}
                name='mobileNumberPart'
                type='text'
                className='form-control col-12'
                placeholder={locales('fields.mobileNumber')}
                maxLength={ENUMS.MAX_LENGTH.mobileNumber}
              />
            </div>
          </div>
          <div className='d-flex flex-wrap justify-content-between mx-1 py-3 px-0'>
            <div className='d-flex flex-wrap justify-content-between col-md-8 col-12'>
              <DatePicker
                marge={true}
                placeholder='از تاریخ'
                name='startDate'
                className='form-control w-full'
                value={startDate}
                onChange={v => setStartDate(v)}
              />
              <DatePicker
                marge={true}
                placeholder='تا تاریخ'
                name='endDate'
                className='form-control w-full'
                value={endDate}
                onChange={v => handleEndDataChange(v)}
              />
            </div>
            <div className='d-flex flex-column col-md-4 col-12 pb-3'>
              <Select
                className='w-full'
                name='cityName'
                id='cityName'
                isMulti={false}
                isClearable={true}
                onChange={event => setCityName(event)}
                placeholder={locales('tables.cityName')}
                options={props.cities?.map(item => ({
                  value: item.name,
                  label: item.name,
                }))}
              />
              {/* <input
                onChange={event => setCityName(event.target.value)}
                value={cityName || ''}
                name='cityName'
                type='text'
                className='form-control col-12'
                placeholder={locales('tables.cityName')}
              /> */}
            </div>
          </div>
          <div className='d-flex justify-content-between mx-1 py-2'>
            <label className='col-1 d-flex align-items-center'>
              {locales('tables.status')}:
            </label>
            <div className='col-10 p-0 d-flex justify-content-start align-items-center'>
              {ENUMS.USER_STATUS.list.map((userStatus, index) => (
                <div
                  className={`col-4 d-flex justify-content-start align-items-center p-0`}
                  key={index}
                >
                  <input
                    type='checkbox'
                    value={userStatus.value}
                    name={`status`}
                    id={`status-${index}`}
                    className=''
                  />
                  <label
                    className='mx-1 my-2 text-center col-6 p-0'
                    htmlFor={`status-${index}`}
                  >
                    {userStatus.title}
                  </label>
                </div>
              ))}
            </div>
          </div>
          <div className='col-12 d-flex justify-content-end p-0'>
            <input
              name='resetButton'
              type='reset'
              value={locales('fields.reset')}
              className='btn btn-danger w-5 mx-2'
            />
            <button
              type='submit'
              id='apply-filter-btn-user'
              className='btn btn-success w-5 mx-2'
            >
              {locales('fields.applyFilters')}
            </button>
          </div>
        </main>
      </form>
    </article>
  );
};

export default UserFilters;
